import { render } from "./selectModal.vue?vue&type=template&id=3ca6f37b&scoped=true&ts=true"
import script from "./selectModal.vue?vue&type=script&lang=ts"
export * from "./selectModal.vue?vue&type=script&lang=ts"

import "./selectModal.vue?vue&type=style&index=0&id=3ca6f37b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca6f37b"]])

export default __exports__